export default "__VITE_ASSET__CkxvEOHY__"